'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuthStore } from '@/features/auth/stores/auth-store';
import { Spinner } from '@softfactura/ui';

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const { isAuthenticated, isLoading, user } = useAuthStore();

  const emailVerified = user?.emailVerified;
  // Adminul aflat în IMPERSONARE nu e trimis la /verify-email: emailul
  // neverificat e al utilizatorului vizualizat, nu al adminului, iar pagina
  // (fără bannerul de ieșire) îl bloca pe admin în browser (incident 2026-07-15).
  const impersonating = user?.impersonating === true;

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      router.replace('/login');
    }
  }, [isLoading, isAuthenticated, router]);

  useEffect(() => {
    if (!isLoading && isAuthenticated && emailVerified === false && !impersonating) {
      router.replace('/verify-email');
    }
  }, [isLoading, isAuthenticated, emailVerified, impersonating, router]);

  // Cât se încarcă, copiii NU rămân montați: la fiecare plecare după o schimbare de identitate
  // (deconectare, altă firmă, alt tab, ieșirea din impersonare) leaveToFreshPage() pune isLoading: true
  // și lasă o randare înainte de navigare, ca formularele nesalvate să se demonteze. Altfel browserul
  // întreabă „Părăsești pagina?”, iar la „Rămâi” pagina rămâne pe identitatea veche cu cookie-ul nou.
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
